export const fallbackProducts = [
  {
    id: 'fallback-office-365',
    name: 'Office 365 Vitalício',
    slug: 'office-365',
    price: 49.9,
    image: '/images/fallback-product.png',
    checkoutUrl: '/checkout'
  },
  {
    id: 'fallback-windows-11',
    name: 'Windows 11 Pro Original',
    slug: 'windows-11-pro',
    price: 59.9,
    image: '/images/fallback-product.png',
    checkoutUrl: '/checkout'
  }
]
